<template>
  <Spot :id="id" />
</template>
<script setup lang="ts">
definePageMeta({
  layout: "spotdetail"
});

const route = useRoute();
const id = route.params.id as string;
</script>
